import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BelgeBolumu = ({ endpoint, kabul }) => {
  const [belgeler, setBelgeler] = useState([]);
  const [seciliDosya, setSeciliDosya] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuc, setSonuc] = useState(null);

  const yukle = () => axios.get(endpoint).then(r => setBelgeler(r.data)).catch(console.error);
  useEffect(() => { yukle(); }, [endpoint]);

  const handleYukle = async e => {
    e.preventDefault();
    if (!seciliDosya) return;
    setYukleniyor(true); setSonuc(null);
    const fd = new FormData();
    fd.append('belge', seciliDosya);
    try {
      await axios.post(endpoint, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setSonuc({ tip: 'basari', mesaj: '"' + seciliDosya.name + '" yuklendi.' });
      setSeciliDosya(null); yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: err.response?.data?.hata || 'Yukleme basarisiz.' }); }
    finally { setYukleniyor(false); }
  };

  const handleSil = async ad => {
    if (!window.confirm('"' + ad + '" silinsin mi?')) return;
    try { await axios.delete(endpoint + '/' + encodeURIComponent(ad)); yukle(); }
    catch { alert('Silme hatasi.'); }
  };

  const fmtBoyut = b => b < 1024 ? b + ' B' : b < 1048576 ? (b/1024).toFixed(1) + ' KB' : (b/1048576).toFixed(1) + ' MB';
  const fmt = t => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

  return (
    <div>
      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}
      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <div className="card-header"><h2>Yeni Belge Yukle</h2></div>
        <form onSubmit={handleYukle}>
          <label className="dosya-alan" htmlFor={'belge-' + endpoint}>
            <input id={'belge-' + endpoint} type="file" accept={kabul || '.pdf,.docx'} onChange={e => setSeciliDosya(e.target.files[0])} />
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gri-400)" strokeWidth="1.5" style={{ margin: '0 auto 8px', display: 'block' }}>
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
            </svg>
            <p>PDF veya DOCX dosyasi secmek icin tiklayin</p>
            {seciliDosya && <div style={{ marginTop: '8px', fontSize: '13px', color: 'var(--yesil)', fontWeight: '500' }}>✓ {seciliDosya.name}</div>}
          </label>
          <div style={{ marginTop: '1rem' }}>
            <button type="submit" className="btn btn-primary" disabled={!seciliDosya || yukleniyor}>
              {yukleniyor ? 'Yukleniyor...' : 'Belgeyi Yukle'}
            </button>
          </div>
        </form>
      </div>
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p style={{ fontSize: '13px', fontWeight: '600' }}>Kayitli Belgeler</p>
          <span className="badge badge-bekliyor">{belgeler.length}</span>
        </div>
        {belgeler.length === 0
          ? <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)', fontSize: '14px' }}>
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>📄</div>
              Henuz belge yuklenmemis.
            </div>
          : <div className="tablo-wrapper">
              <table>
                <thead><tr><th>Dosya Adi</th><th>Boyut</th><th>Tarih</th><th></th></tr></thead>
                <tbody>
                  {belgeler.map(b => (
                    <tr key={b.ad}>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--kirmizi)" strokeWidth="1.5">
                            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                            <polyline points="14 2 14 8 20 8"/>
                          </svg>
                          <span style={{ fontWeight: '500', fontSize: '13px' }}>{b.ad}</span>
                        </div>
                      </td>
                      <td style={{ color: 'var(--yazi-ikincil)', fontSize: '13px' }}>{fmtBoyut(b.boyut)}</td>
                      <td style={{ fontSize: '13px' }}>{fmt(b.tarih)}</td>
                      <td><button type="button" className="btn btn-danger btn-sm" onClick={() => handleSil(b.ad)}>Sil</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
        }
      </div>
    </div>
  );
};

const sekmeler = [
  { key: 'vize', label: 'Vize Belgeleri', aciklama: 'Her vize talebine otomatik eklenecek belgeler.', endpoint: '/api/admin/belgeler' },
  { key: 'isealim', label: 'Ise Alim Belgeleri', aciklama: 'Is teklifi, sozlesme ve sablon belgeler.', endpoint: '/api/admin/belgeler-isealim' },
  { key: 'izin', label: 'Izin Belgeleri', aciklama: 'Izin onay formları ve ilgili belgeler.', endpoint: '/api/admin/belgeler-izin' },
];

const BelgeYonetimPage = () => {
  const [aktif, setAktif] = useState('vize');
  const secili = sekmeler.find(s => s.key === aktif);

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Belge Yonetimi</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Vize, ise alim ve izin belgelerini tek yerden yonetin.</p>
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        {sekmeler.map(s => (
          <button key={s.key} type="button" onClick={() => setAktif(s.key)}
            style={{ padding: '0.6rem 1.25rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: aktif === s.key ? '600' : '400', color: aktif === s.key ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: aktif === s.key ? '2px solid var(--mavi)' : '2px solid transparent', whiteSpace: 'nowrap' }}>
            {s.label}
          </button>
        ))}
      </div>

      <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)', marginBottom: '1.5rem' }}>{secili.aciklama}</p>

      <BelgeBolumu key={aktif} endpoint={secili.endpoint} kabul=".pdf,.docx" />
    </div>
  );
};

export const VizeBelgeleriPage = () => <BelgeYonetimPage />;
export const IseAlimBelgeleriPage = () => <BelgeYonetimPage />;
export const IzinBelgeleriPage = () => <BelgeYonetimPage />;
export default BelgeYonetimPage;
